import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { showToast } from "../../../../utils/showToast";
import { usePermissions } from "../../../../utils/permissions";
import "../../../../styles/dashboardTheme.css";
import "../../../../styles/managementTheme.css";
import UsuariosSummary from "../components/UsuariosSummary.jsx";
import UsuariosFilters from "../components/UsuariosFilters.jsx";
import UsuariosTableSection from "../components/UsuariosTableSection.jsx";
import UsuarioFormModal from "../components/UsuarioFormModal.jsx";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal.jsx";
import "../styles/usuarios.css";

export default function UsuariosView({
    data,
    state,
    alerts,
    filters,
    forms,
    modal,
    actions,
    saving,
    utils,
}) {
    const { usuarios, roles, centros, resumen, activeQuickFilter, filteredUsuarios } = data;
    const { loading, listError, rolesLoading, centrosLoading } = state;
    const { alerta, dismissAlert } = alerts;
    const {
        search,
        setSearch,
        roleFilter,
        setRoleFilter,
        statusFilter,
        setStatusFilter,
        centerFilter,
        setCenterFilter,
        limpiarFiltros,
    } = filters;
    const {
        nuevo,
        editar,
    } = forms;
    const formNuevo = nuevo.values;
    const setFormNuevo = nuevo.setValues;
    const formEditar = editar.values;
    const setFormEditar = editar.setValues;
    const {
        usuarioSeleccionado,
        abrirModalNuevo,
        abrirModalEditar,
        abrirModalEliminar,
        cerrarModal,
        isNuevo,
        isEditar,
        isEliminar,
    } = modal;
    const {
        handleCrearUsuario,
        handleActualizarUsuario,
        handleEliminarUsuario,
        handleDesbloquearUsuario,
        loadUsuarios,
        aplicarKpiFiltro,
    } = actions;
    const { savingNuevo, savingEdicion, deleting, unlockingId } = saving;
    const { getSuggestedUsername } = utils;

    const { hasPermission } = usePermissions();
    const canManageUsers = hasPermission("manage_users");
    const canCreate = canManageUsers;
    const canEdit = canManageUsers;
    const canDelete = canManageUsers;

    useEffect(() => {
        if (alerta?.message) {
            showToast({
                type: alerta.type || "info",
                message: alerta.message,
                onClose: dismissAlert,
            });
        }
    }, [alerta, dismissAlert]);

    const isFormOpen = isNuevo || isEditar;
    const activeForm = isEditar ? formEditar : formNuevo;
    const setActiveForm = isEditar ? setFormEditar : setFormNuevo;
    const savingForm = isEditar ? savingEdicion : savingNuevo;
    const submitForm = isEditar ? handleActualizarUsuario : handleCrearUsuario;
    const usernamePreview = isEditar
        ? usuarioSeleccionado?.username
        : getSuggestedUsername(formNuevo);

    return (
        <section className="management-page management-theme-amber usuarios-page">
            <UsuariosHeader canCreate={canCreate} onNew={abrirModalNuevo} />

            <UsuariosSummary
                resumen={resumen}
                activeKey={activeQuickFilter}
                onQuickFilter={aplicarKpiFiltro}
            />

            <UsuariosFilters
                search={search}
                setSearch={setSearch}
                roleFilter={roleFilter}
                setRoleFilter={setRoleFilter}
                statusFilter={statusFilter}
                setStatusFilter={setStatusFilter}
                centerFilter={centerFilter}
                setCenterFilter={setCenterFilter}
                roles={roles}
                centros={centros}
                limpiarFiltros={limpiarFiltros}
            />

            <UsuariosTableSection
                loading={loading}
                error={listError}
                filteredUsuarios={filteredUsuarios}
                totalUsuarios={usuarios.length}
                canCreate={canCreate}
                onCreate={abrirModalNuevo}
                canEdit={canEdit}
                canDelete={canDelete}
                onEdit={abrirModalEditar}
                onDelete={abrirModalEliminar}
                onUnlock={handleDesbloquearUsuario}
                unlockingId={unlockingId}
                onRetry={loadUsuarios}
            />

            <UsuarioFormModal
                open={isFormOpen}
                isEdit={isEditar}
                usuarioId={usuarioSeleccionado?.id}
                form={activeForm}
                setForm={setActiveForm}
                roles={roles}
                rolesLoading={rolesLoading}
                centros={centros}
                centrosLoading={centrosLoading}
                onClose={cerrarModal}
                onSubmit={submitForm}
                saving={savingForm}
                canSubmit={canManageUsers}
                usernamePreview={usernamePreview}
            />

            <ConfirmDeleteModal
                open={isEliminar && !!usuarioSeleccionado && canDelete}
                usuario={usuarioSeleccionado}
                onClose={cerrarModal}
                onConfirm={handleEliminarUsuario}
                deleting={deleting}
            />
        </section>
    );
}

function UsuariosHeader({ canCreate, onNew }) {
    return (
        <div className="management-card management-header mb-4">
            <div>
                <p className="dashboard-eyebrow mb-1">Administracion</p>
                <h4 className="dashboard-title mb-0">Gestion de usuarios</h4>
                <small className="text-muted">Controla el directorio interno y sus accesos.</small>
            </div>
            {canCreate && (
                <button className="btn management-btn-primary" onClick={onNew}>
                    + Nuevo usuario
                </button>
            )}
        </div>
    );
}
